(function() {
  'use strict';

  /* ============================================================
     SARKOLÉ THEME — global.js
     Vanilla JS replacements for Hydrogen React behaviors.
     ============================================================ */

  // ---------- Reveal Animations ----------
  function initReveal() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      document.querySelectorAll('.reveal').forEach((el) => el.classList.add('visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
  }

  // ---------- Theme Color ----------
  function initThemeColor() {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    const update = () => meta.setAttribute('content', window.scrollY > 50 ? '#FFFFFF' : '#000000');
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ---------- Smooth Scroll ----------
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const href = anchor.getAttribute('href');
        if (!href || href === '#') return;
        const target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ---------- Lazy Images ----------
  function initLazyImages() {
    if ('loading' in HTMLImageElement.prototype) return;
    const images = document.querySelectorAll('img[loading="lazy"]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          observer.unobserve(img);
        }
      });
    });
    images.forEach((img) => observer.observe(img));
  }

  // ---------- Cart Drawer (AJAX) ----------
  const Cart = {
    items: [],
    isOpen: false,

    async load() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.items = cart.items || [];
        this.updateCount(cart.item_count || 0);
        window.dispatchEvent(new CustomEvent('cart:loaded', { detail: cart }));
      } catch (e) {
        console.error('Cart load failed', e);
      }
    },

    async add(variantId, quantity = 1) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ id: variantId, quantity }),
        });
        const data = await res.json();
        console.log('Cart add response:', data);
        if (data.items) {
          this.items = data.items;
          this.updateCount(data.item_count || data.items.length);
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          this.open();
        } else if (data.description) {
          console.error('Cart add failed:', data.description);
          alert('Could not add to cart: ' + data.description);
        } else {
          console.error('Cart add failed: unknown response', data);
          alert('Could not add to cart. Please check product availability.');
        }
      } catch (e) {
        console.error('Cart add failed', e);
        alert('Could not add to cart. Please try again.');
      }
    },

    async change(line, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ line, quantity }),
        });
        const data = await res.json();
        this.items = data.items || [];
        this.updateCount(data.item_count || data.items.length);
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      } catch (e) {
        console.error('Cart change failed', e);
      }
    },

    updateCount(count) {
      const desktop = document.getElementById('cart-badge-desktop');
      const mobile = document.getElementById('cart-badge-mobile');
      if (desktop) desktop.textContent = count;
      if (mobile) mobile.textContent = count;
    },

    open() {
      this.isOpen = true;
      window.dispatchEvent(new CustomEvent('cart:open'));
      this.load();
    },

    close() {
      this.isOpen = false;
      window.dispatchEvent(new CustomEvent('cart:close'));
    },
  };
  window.Cart = Cart;   // ponytail: expose so hero.liquid reuses the same add/drawer path

  // ---------- Product Form Add to Cart ----------
  // ponytail: prevents default form submit, uses Cart.add() AJAX instead of page redirect
  function initProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.id === 'hero-cart-form') return;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var variantInput = form.querySelector('input[name="id"], select[name="id"]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        if (variantInput) {
          var variantId = parseInt(variantInput.value);
          var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
          Cart.add(variantId, qty);
        }
      });
    });
  }

  // ---------- Reviews Toggle ----------
  function initReviews() {
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-reviews-summary-toggle]');
      if (!toggle) return;
      var tags = toggle.parentNode.querySelector('[data-reviews-summary-tags]');
      if (!tags) return;
      var hidden = tags.classList.toggle('reviews-summary-tags--hidden');
      var label = toggle.querySelector('[data-reviews-summary-toggle-text]');
      if (label) {
        label.textContent = hidden ? 'Show Reviews Summary' : 'Hide Reviews Summary';
      }
    });
  }

  // ---------- Accordions ----------
  function initAccordions() {
    document.querySelectorAll('.accordion-section').forEach((section) => {
      const header = section.querySelector('h4');
      if (!header) return;
      header.style.cursor = 'pointer';
      header.addEventListener('click', () => {
        section.classList.toggle('is-open');
      });
    });
  }

  // ---------- Video Toggle ----------
  function initVideo() {
    const toggle = document.getElementById('video-toggle');
    const desktopVideo = document.getElementById('desktop-video');
    const mobileVideo = document.getElementById('mobile-video');
    if (!toggle || !desktopVideo) return;

    function getActive() {
      return window.innerWidth >= 768 ? desktopVideo : mobileVideo;
    }

    toggle.addEventListener('click', () => {
      const video = getActive();
      if (!video) return;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  }

  // ---------- Boot ----------
  function boot() {
    initReveal();
    initThemeColor();
    initSmoothScroll();
    initLazyImages();
    Cart.load();
    initProductForms();
    initReviews();
    initAccordions();
    initVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
